import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

class DateTimeAfterNowValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        element: JQuery,
        attributes: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpDatetimeAfterNowValidator'] = this.validate;
    };

    private validate(modelValue) {
        if (!modelValue || !modelValue) {
            return true;
        }

        var runtimeStart = moment(modelValue);

        return runtimeStart.isAfter(moment.now());
    }
}

angular
    .module('app')
    .directive(
        'pkpDatetimeAfterNowValidator',
        () => new DateTimeAfterNowValidator()
    );
